import { render, staticRenderFns } from "./salecontractdetail.vue?vue&type=template&id=252ed4ca&scoped=true&"
import script from "./salecontractdetail.vue?vue&type=script&lang=js&"
export * from "./salecontractdetail.vue?vue&type=script&lang=js&"
import style0 from "./salecontractdetail.vue?vue&type=style&index=0&id=252ed4ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ed4ca",
  null
  
)

export default component.exports